export var CELL_STRIDE = 2;
export var CELL_SIZE = 12;
//# sourceMappingURL=config.js.map